export default __webpack_public_path__ + "static/media/1772.1bc86d8d.png";